import React from "react";
import { Link } from "react-router-dom";
import ro from "/src/content/ro.json";

const Flooter = () => {
  return (
    <footer
      id="contact"
      className="flooter-container pt-12 pb-8"
      style={{
        backgroundColor: "var(--color-bg)",
        color: "var(--color-text)",
        borderTop: "1px solid var(--color-border)",
      }}
    >
      {/* ---------------------- GRID PRINCIPAL ---------------------- */}
      <div className="flooter-content mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-6 sm:grid-cols-2 lg:grid-cols-4">
        {/* ------------------ DESPRE FIRMA ------------------ */}
        <div className="flooter-section space-y-4">
          <h3 className="flooter-title text-orange-500 text-lg font-semibold tracking-tight">
            {ro.footer.about.title}
          </h3>
          <p className="max-w-[34ch] text-sm leading-relaxed opacity-90">
            {ro.footer.about.textBefore}{" "}
            <strong>{ro.footer.about.textStrong}</strong>
            {ro.footer.about.textAfter}
          </p>

          <p className="max-w-[34ch] text-xs leading-relaxed opacity-80">
            {ro.footer.about.note}
          </p>

          <div className="pt-3 text-xs leading-relaxed opacity-80">
            <div
              className="mb-2 h-px w-12"
              style={{ backgroundColor: "var(--color-border)" }}
            ></div>
            <div className="space-y-1">
              <p>
                <strong>{ro.footer.about.cuiLabel}</strong> {ro.footer.about.cuiValue}
              </p>
              <p>
                <strong>{ro.footer.about.regLabel}</strong> {ro.footer.about.regValue}
              </p>
              <p>
                <strong>{ro.footer.about.sediuLabel}</strong>{" "}
                {ro.footer.about.sediuValue}
              </p>
            </div>
          </div>
        </div>

        {/* ------------------ CONTACT ------------------ */}
        <div className="flooter-section space-y-4">
          <h3 className="flooter-title text-orange-500 text-lg font-semibold tracking-tight">
            {ro.footer.contact.title}
          </h3>

          <div className="space-y-2">
            <p className="text-xs uppercase tracking-wide opacity-70">
              {ro.footer.contact.emailLabel}
            </p>
            <a
              href="mailto:alexandrustefan.97@yahoo.com"
              className="text-orange-500 text-sm font-semibold underline-offset-4 hover:underline"
            >
              {ro.footer.contact.email}
            </a>
          </div>

          <div className="space-y-2">
            <p className="text-xs uppercase tracking-wide opacity-70">
              {ro.footer.contact.phoneLabel}
            </p>
            <p className="text-base font-semibold">{ro.footer.contact.phone}</p>
          </div>

          {/* ANPC + SOL – obligatorii in RO */}
          <div className="space-y-2 pt-2 text-xs opacity-80">
            <a
              href="https://anpc.ro/"
              target="_blank"
              rel="noreferrer"
              className="block underline-offset-4 hover:underline"
            >
              {ro.footer.contact.anpc}
            </a>
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noreferrer"
              className="block underline-offset-4 hover:underline"
            >
              {ro.footer.contact.sol}
            </a>
          </div>
        </div>

        {/* ------------------ LINK-URI UTILE ------------------ */}
        <div className="flooter-section space-y-4">
          <h3 className="flooter-title text-orange-500 text-lg font-semibold tracking-tight">
            {ro.footer.links.title}
          </h3>
          <ul className="space-y-3 text-sm">
            {ro.footer.links.items.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="block transition-colors hover:text-orange-500"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* ------------------ GDPR + LEGAL ------------------ */}
        <div className="flooter-section space-y-4">
          <h3 className="flooter-title text-orange-500 text-lg font-semibold tracking-tight">
            {ro.footer.legal.title}
          </h3>
          <ul className="space-y-3 text-sm">
            {ro.footer.legal.items.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="block transition-colors hover:text-orange-500"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* ---------------------- SUBSOL FINAL ---------------------- */}
      <div className="flooter-bottom mt-12 border-t border-black/10 px-4 pt-6 text-center dark:border-white/10">
        <p className="text-xs leading-relaxed opacity-70">
          {ro.footer.bottom.recaptchaBefore}{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer noopener"
            className="underline underline-offset-4"
          >
            {ro.footer.bottom.privacyLabel}
          </a>{" "}
          {ro.footer.bottom.between}{" "}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noreferrer noopener"
            className="underline underline-offset-4"
          >
            {ro.footer.bottom.termsLabel}
          </a>{" "}
          {ro.footer.bottom.recaptchaAfter}{" "}
          <a
            href="https://www.fiverr.com/s/o895pvx"
            target="_blank"
            rel="noreferrer noopener"
            className="font-semibold text-orange-500 hover:text-orange-400 underline underline-offset-4"
          >
            {ro.footer.bottom.author}
          </a>
          .
        </p>
      </div>
    </footer>
  );
};

export { Flooter };
export default Flooter;
